// import CardMaster from 'components/Product/CardMaster';
import DynamicCardSizer from 'components/Product/DynamicCardSizer';
import { productGetSplash } from 'lib/product';
import { CGProduct } from 'types/shopify';
import { DynamicCarouselSlideItem } from './DynamicCarousel';
export const productToSlideItem = (
  //
  product: CGProduct,
  initial: DynamicCarouselSlideItem = {},
  override: DynamicCarouselSlideItem = {},
): DynamicCarouselSlideItem => {
  return {
    ...initial,
    bodyElement: <DynamicCardSizer noButton item={product} size="small" />,
    backgroundImage: productGetSplash(product) || undefined,
    caption: product.pd?.abstract,
    buttonLabel: `Discover ${product.title}`,
    buttonTo: `/product/${product.handle}`,
    buttonUseClick: true, // We don't want react-snap following...
    options: {
      ignoreBackground: true, // We hide the background as it is extracted by the parent...
      ignoreTitles: true, // We hide the titles as they are extracted by the parent...
    },
    ...override,
  };
};
